export const ru = {
    'amnesty-price': 'Списываемая цена',
    'amnesty-price-with-currency': 'Списываемая цена, {currency}',
    audience_coverage: 'Охват аудитории',
    banners: 'Объявления',
    'bid-forecast': 'Прогноз ставки',
    'campaign-group': 'Кампания/группа',
    'campaign-type': 'Тип кампании',
    'context-click-price': 'Цена клика в сетях',
    'context-price': 'Ставка (в сетях)',
    'context-price-cpm': 'Ставка за тыс. показов',
    'context-price-with-currency': 'Ставка (в сетях), {currency}',
    'context-price-with-currency-cpm-banner':
        'Ставка за тыс. показов, {currency}',
    coverage: 'Охват',
    'coverage-with-percent': 'Охват, %',
    ectr: 'eCTR',
    phrase: 'Ключевые фразы',
    position: 'Позиция',
    price: 'Ставка',
    'price-with-currency': 'Ставка, {currency}',
    priority: 'Приоритет',
    status: 'Статус',
    'traffic-forecast': 'Прогноз трафика'
};
